export default "__VITE_ASSET__SKoXRUwh__"